@import '../../styles/modals.css';
@import '../../styles/form.css';
@import '../../styles/buttons.css';

.tambr-form-item-row .tambr-form-item:last-child { 
  margin-left: 0;
  margin-right: 0;
}

.checkbox-wrapper{
  margin-top: 10px;
}

.checkbox-wrapper input {
  vertical-align: middle;
  margin-right: 0.3rem;
}

.checkbox-wrapper input:focus+label {
  font-size: inherit;
  transition: none;
}
